import { useMemo } from 'react';
import type { SegmentTreeNode } from '../../../../../../../../../../modules/audiences/AudienceForm/types.ts';

export const useDistrictFilter = (data: SegmentTreeNode[], query: string) => {
  const filtered: SegmentTreeNode[] = useMemo(() => {
    if (!query.trim()) return data;

    const phrase = query.toLowerCase();

    return data
      .map(districtSegment => {
        const childMatches: SegmentTreeNode[] =
          districtSegment.children?.filter(
            segment => segment.name.toLowerCase().includes(phrase) || segment.id.toLowerCase().includes(phrase)
          ) || [];

        const stateMatches = districtSegment.name.toLowerCase().includes(phrase);

        if (stateMatches) return districtSegment;

        if (childMatches.length) {
          return { ...districtSegment, children: childMatches };
        }

        return null;
      })
      .filter(Boolean) as SegmentTreeNode[];
  }, [data, query]);

  return filtered;
};
